import { useFilterQuestionnaireContext } from "./filter-questionnaire.context";

export function FilterQuestionnaire() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterQuestionnaireContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}